import { render, staticRenderFns } from "./eCommCogsChannelText.vue?vue&type=template&id=ff8f6a34&scoped=true"
import script from "./eCommCogsChannelText.vue?vue&type=script&lang=js"
export * from "./eCommCogsChannelText.vue?vue&type=script&lang=js"
import style0 from "./eCommCogsChannelText.vue?vue&type=style&index=0&id=ff8f6a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8f6a34",
  null
  
)

export default component.exports